﻿import { IEmailSendee } from './email-sendee';

export interface IEmailSendeeRequest {
    emailTemplateId: number;
    sendee: IEmailSendee;
}
